(function(){
  var d=document;
  var COL={'TOASTY BROWN':'#AF644C','SOFT BROWN':'#BB6A60','ROSEWOOD':'#F17F98','03 ICON':'#E0AFB7','04 BROWN SUGAR':'#BD6B56','05 BOMBSHELL':'#BC4E5F'};
  function cap(s){return s.toLowerCase().replace(/\b\w/g,function(c){return c.toUpperCase()})}
  function sized(u,w){return u.replace(/(\.[a-zA-Z]+)(\?|$)/,'_'+w+'x$1$2')}

  /* shade dots in the bundle boxes: paint the real shade colour (they default to grey) */
  function paintDots(){
    d.querySelectorAll('.tlp-dot').forEach(function(dot){
      var host=dot.parentNode;var g=host&&host.querySelector('.tlp-grow');if(!g)return;
      var t=(g.firstChild&&g.firstChild.nodeType===3?g.firstChild.textContent:g.textContent).trim().toUpperCase();
      var c=COL[t];if(c&&dot.getAttribute('data-c')!==c){dot.style.background=c;dot.setAttribute('data-c',c)}
    });
  }
  (function(){
    var busy=false;
    function run(){if(busy)return;busy=true;try{paintDots()}catch(e){}busy=false}
    function start(){run();var r=d.querySelector('.tlp');if(r)new MutationObserver(run).observe(r,{childList:true,subtree:true})}
    if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',start);else start();
  })();

  /* FREE GIFTS: when a bundle adds its free gift (cart line property _gift), swap the real product for the matching hidden $0 gift variant.
     original variant id -> free gift variant id (same shade) */
  var GM={
    54100234174836:56507015594356,
    55004054815092:56507015922036,55004054847860:56507015954804,55004054880628:56507015987572,
    56261946933620:56507016020340,55256214667636:56507016053108,56436019659124:56507016085876
  };
  try{
    var _f=window.fetch;
    window.fetch=function(u,o){
      try{
        var url=typeof u==='string'?u:((u&&u.url)||'');
        if(/\/cart\/add/.test(url)&&o&&typeof o.body==='string'){
          var b=JSON.parse(o.body);
          if(b&&b.items){
            b.items.forEach(function(it){if(it&&it.properties&&it.properties._gift&&GM[it.id])it.id=GM[it.id]});
            o=Object.assign({},o,{body:JSON.stringify(b)});
          }
        }
      }catch(e){}
      return _f.call(this,u,o);
    };
  }catch(e){}

  /* hide the old "The shades / Find your edge|shade" section on contour + peel off pages (the tappable shade buttons above the bundles replace it) */
  (function(){var s=d.createElement('style');s.id='tdt-hide-shades';s.textContent='.tlp-sec:has(.tlp-shade){display:none!important}.tlp-sec[data-x-hide]{display:none!important}'+
    /* "Get jelly-stained lips": text first, picture below the writing */
    '.tlp-hack[data-x-jelly]{grid-template-columns:1fr!important;max-width:640px!important;text-align:center}.tlp-hack[data-x-jelly]>div:first-child{order:2}.tlp-hack[data-x-jelly] ol{text-align:left;display:inline-grid}.tlp-hack[data-x-jelly] img{max-height:560px;object-fit:cover}'+
    /* peptide page: keep the photo column inside the phone screen (the thumbnail scroller was stretching the page) */
    '.tpp-buy>*,.tpp>*{min-width:0;max-width:100%}.tpp-buy .tpp-img{max-width:100%;height:auto}.tpp-buy .tlp-thumbs{max-width:100%;width:100%;box-sizing:border-box}.tpp{overflow-x:clip}';
    (d.head||d.documentElement).appendChild(s)})();
  function hideShades(){
    d.querySelectorAll('.tlp-sec').forEach(function(sec){
      var h=sec.querySelector('.tlp-head h2');
      if(h&&/find your (shade|edge)/i.test(h.textContent))sec.setAttribute('data-x-hide','1');
    });
    d.querySelectorAll('.tlp-hack').forEach(function(sec){
      var h=sec.querySelector('h2');
      if(h&&/jelly/i.test(h.textContent))sec.setAttribute('data-x-jelly','1');
    });
  }

  /* product photos inside the bundle box: Peptide (free gift in 2 Pair + "Complete the look") and the free gift in the 3 Pair (changes with the chosen shade) */
  function pepThumbs(){
    var root=d.querySelector('.tlp');if(!root)return;
    var st=d.createElement('style');st.id='tx-pep-css';
    st.textContent='.tx-pep{width:54px;height:54px;border-radius:10px;object-fit:cover;flex:none;display:block;background:#fff;box-shadow:inset 0 0 0 1px rgba(0,0,0,.06)}.tx-gimg{width:56px;height:56px;border-radius:10px;object-fit:cover;flex:none;display:block;background:#fff;box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)}.tx-gimg.sm{width:40px;height:40px;border-radius:8px}.tlp-dd-b[data-key=g]{padding:8px 14px 8px 8px}';
    d.head.appendChild(st);
    var onPeel=/peel-off/.test(location.pathname);
    var giftHandle=onPeel?'teinte-12-hour-dual-sided-lip-contour-stain':'teinte-all-day-peel-off-lip-stain';
    var pep=null,gift={};
    function apply(){
      root.querySelectorAll('.tlp-gift,.tlp-up').forEach(function(el){
        if(pep&&!el.querySelector('.tx-pep')){var im=d.createElement('img');im.className='tx-pep';im.src=pep;im.alt='Peptide Lip Treatment';im.loading='lazy';el.insertBefore(im,el.firstChild)}
      });
      root.querySelectorAll('.tlp-dd-b[data-key=g],.tlp-opt[data-key=g]').forEach(function(el){
        if(el.querySelector('.tx-gimg'))return;
        var g=el.querySelector('.tlp-grow');if(!g)return;
        var name=(g.firstChild&&g.firstChild.nodeType===3?g.firstChild.textContent:g.textContent).trim();
        var u=gift[name];if(!u)return;
        var im=d.createElement('img');im.className='tx-gimg'+(el.classList.contains('tlp-opt')?' sm':'');im.src=sized(u,160);im.alt=name;im.loading='lazy';
        el.insertBefore(im,el.firstChild);
      });
    }
    var busy=false;
    function safe(){if(busy)return;busy=true;try{apply()}catch(e){}busy=false}
    fetch('/products/teinte-peptide-lip-treatment.js').then(function(r){return r.json()}).then(function(p){
      var u=(p.featured_image||(p.images&&p.images[0])||'');if(u)pep=sized(u,160);safe();
    }).catch(function(){});
    fetch('/products/'+giftHandle+'.js').then(function(r){return r.json()}).then(function(p){
      p.variants.forEach(function(v){var im=(v.featured_image&&v.featured_image.src)||p.featured_image;if(im)gift[v.title]=im});
      safe();
    }).catch(function(){});
    new MutationObserver(safe).observe(root,{childList:true,subtree:true});
  }

  /* reels carousel: sits right under the buy block (under the delivery row) */
  function reels(){
    var r=d.querySelector('.trl');var buy=d.querySelector('.tlp-buy');
    if(r&&buy&&buy.nextElementSibling!==r)buy.parentNode.insertBefore(r,buy.nextSibling);
  }

  /* ---- delivery tracker under the add-to-bag button (dates are estimates from today) ---- */
  function tracker(){
    var anchor=d.querySelector('.tlp-trust,.tpp-trust');
    if(!anchor||d.querySelector('.tdt'))return;
    var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function fmt(n){var x=new Date();x.setDate(x.getDate()+n);return M[x.getMonth()]+' '+x.getDate()}
    function rng(a,b){return fmt(a)+' - '+fmt(b)}
    var ico={
      bag:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
      truck:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h11v10H2z"/><path d="M13 10h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>',
      box:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/></svg>'
    };
    if(!d.getElementById('tdt-css')){
      var st=d.createElement('style');st.id='tdt-css';
      st.textContent='.tdt{margin:16px 0 4px;padding:16px 8px 12px;background:#fff;border:1px solid #E6E6E9;border-radius:14px;font-family:"DM Sans",sans-serif}'+
      '.tdt-r{display:flex;align-items:flex-start;justify-content:space-between;position:relative}'+
      '.tdt-s{flex:0 0 33.333%;display:flex;flex-direction:column;align-items:center;text-align:center;position:relative;z-index:1}'+
      '.tdt-c{width:46px;height:46px;border-radius:50%;background:#F2EFF7;color:#3B4081;display:flex;align-items:center;justify-content:center;margin-bottom:8px}'+
      '.tdt-s:nth-child(3) .tdt-c{background:#3B4081;color:#fff}'+
      '.tdt-s b{font-size:12.5px;line-height:1.2;color:#121212}'+
      '.tdt-s span{font-size:11.5px;color:#6B6A72;margin-top:3px;line-height:1.3}'+
      '.tdt-l{position:absolute;top:23px;height:0;border-top:2px dashed #CFCBDD;z-index:0}'+
      '.tdt-l.a{left:calc(16.666% + 30px);right:calc(50% + 30px)}'+
      '.tdt-l.b{left:calc(50% + 30px);right:calc(16.666% + 30px)}'+
      '.tdt-n{text-align:center;font-size:11px;color:#8B8A92;margin:12px 0 0}';
      d.head.appendChild(st);
    }
    var el=d.createElement('div');el.className='tdt';
    el.innerHTML='<div class="tdt-r"><i class="tdt-l a"></i><i class="tdt-l b"></i>'+
      '<div class="tdt-s"><div class="tdt-c">'+ico.bag+'</div><b>Ordered</b><span>Today</span></div>'+
      '<div class="tdt-s"><div class="tdt-c">'+ico.truck+'</div><b>Shipped</b><span>'+rng(0,1)+'</span></div>'+
      '<div class="tdt-s"><div class="tdt-c">'+ico.box+'</div><b>Delivered</b><span>'+rng(1,3)+'</span></div></div>'+
      '<p class="tdt-n">Estimated delivery within Lebanon</p>';
    anchor.parentNode.insertBefore(el,anchor);
  }

  /* ---- peptide page: tappable + swipeable gallery (same as contour) ---- */
  function peptide(){
    var main=d.querySelector('.tpp-img');var old=d.querySelector('.tpp-thumbs');
    if(!main||!old||old.getAttribute('data-g'))return;
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);
    var handle=m?m[1]:'teinte-peptide-lip-treatment';
    fetch('/products/'+handle+'.js').then(function(r){return r.json()}).then(function(p){
      var list=(p.media&&p.media.length?p.media.filter(function(x){return x.media_type==='image'}).map(function(x){return x.src}):p.images)||[];
      if(list.length<2)return;
      var cur=0;
      var h='';list.forEach(function(u,i){h+='<button type="button" class="tlp-tb" data-i="'+i+'" aria-label="Show photo '+(i+1)+'"><img src="'+sized(u,260)+'" alt="" loading="lazy"></button>'});
      var th=d.createElement('div');th.className='tlp-thumbs';th.setAttribute('data-g','1');th.innerHTML=h;
      old.parentNode.replaceChild(th,old);
      th.style.maxWidth='100%';th.style.marginTop='10px';
      function go(i){
        if(i<0)i=list.length-1;if(i>=list.length)i=0;cur=i;
        main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=sized(list[i],1000);
        th.querySelectorAll('.tlp-tb').forEach(function(b){var on=+b.getAttribute('data-i')===i;b.classList.toggle('on',on);if(on){try{th.scrollTo({left:b.offsetLeft-th.clientWidth/2+b.clientWidth/2,behavior:'smooth'})}catch(e){}}});
      }
      th.addEventListener('click',function(e){var b=e.target.closest('.tlp-tb');if(b)go(+b.getAttribute('data-i'))});
      var sx=null;
      main.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
      main.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>40)go(cur+(dx<0?1:-1))},{passive:true});
      var s0=list.map(function(u){return u.split('?')[0]}).indexOf((main.getAttribute('src')||'').split('?')[0].replace(/_\d+x(\.\w+)$/,'$1'));
      go(s0>0?s0:0);
    }).catch(function(){});
  }

  function init(){
    hideShades();
    reels();
    pepThumbs();
    tracker();
    peptide();
    var root=d.querySelector('.tlp');if(!root)return;
    var hb=root.querySelector('.tlp-hd b');if(hb&&/choose your bundle/i.test(hb.textContent))hb.textContent='More shades, more savings';
    var media=root.querySelector('.tlp-media');if(!media)return;
    var main=media.querySelector('.tlp-img');var thumbs=media.querySelector('.tlp-thumbs');
    if(!main||!thumbs)return;
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);
    var handle=m?m[1]:'teinte-12-hour-dual-sided-lip-contour-stain';
    fetch('/products/'+handle+'.js').then(function(r){return r.json()}).then(function(p){
      var all=(p.media&&p.media.length?p.media.filter(function(x){return x.media_type==='image'}).map(function(x){return x.src}):p.images)||[];
      var vimg={},vorder=[];
      p.variants.forEach(function(v){if(v.featured_image&&v.featured_image.src){vimg[v.id]=v.featured_image.src;if(vorder.indexOf(v.featured_image.src)<0)vorder.push(v.featured_image.src)}});
      var list=vorder.slice();all.forEach(function(u){if(list.indexOf(u)<0)list.push(u)});
      if(list.length<2)return;
      var cur=0;
      var h='';list.forEach(function(u,i){h+='<button type="button" class="tlp-tb" data-i="'+i+'" aria-label="Show photo '+(i+1)+'"><img src="'+sized(u,260)+'" alt="" loading="lazy"></button>'});
      thumbs.innerHTML=h;
      var sw=null;
      function go(i){
        if(i<0)i=list.length-1;if(i>=list.length)i=0;cur=i;
        main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=sized(list[i],1000);
        thumbs.querySelectorAll('.tlp-tb').forEach(function(b){var on=+b.getAttribute('data-i')===i;b.classList.toggle('on',on);if(on&&b.scrollIntoView){try{thumbs.scrollTo({left:b.offsetLeft-thumbs.clientWidth/2+b.clientWidth/2,behavior:'smooth'})}catch(e){}}});
        if(sw)sw.querySelectorAll('.tlp-sw').forEach(function(b){b.classList.toggle('on',+b.getAttribute('data-i')===i)});
      }
      var hd=root.querySelector('.tlp-hd');
      var shades=[];
      p.variants.forEach(function(v){var k=v.title.toUpperCase();if(COL[k]&&v.featured_image){var i=list.indexOf(v.featured_image.src);if(i>=0)shades.push({n:v.title,c:COL[k],i:i})}});
      if(hd&&shades.length>1){
        sw=d.createElement('div');sw.className='tlp-sws';
        var s='<div class="tlp-sws-t"><b>The shades</b><span>Tap a shade to see it</span></div><div class="tlp-sws-r">';
        shades.forEach(function(x){s+='<button type="button" class="tlp-sw" data-i="'+x.i+'" aria-label="'+cap(x.n)+'"><i style="background:'+x.c+'"></i><em>'+cap(x.n)+'</em></button>'});
        sw.innerHTML=s+'</div>';
        hd.parentNode.insertBefore(sw,hd);
        sw.addEventListener('click',function(e){
          var b=e.target.closest('.tlp-sw');if(!b)return;
          go(+b.getAttribute('data-i'));
          /* on mobile the photo is above the shade buttons: scroll back up to it */
          if(window.innerWidth<750){
            var hdr=d.querySelector('.section-header,.header-wrapper,header');
            var off=(hdr&&hdr.getBoundingClientRect().height||60)+10;
            var y=media.getBoundingClientRect().top+window.pageYOffset-off;
            try{window.scrollTo({top:Math.max(0,y),behavior:'smooth'})}catch(err){window.scrollTo(0,Math.max(0,y))}
          }
        });
      }
      thumbs.addEventListener('click',function(e){var b=e.target.closest('.tlp-tb');if(b)go(+b.getAttribute('data-i'))});
      var sx=null;
      main.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
      main.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>40)go(cur+(dx<0?1:-1))},{passive:true});
      root.addEventListener('click',function(e){var o=e.target.closest('.tlp-opt');if(!o)return;var id=o.getAttribute('data-id');var u=vimg[id];if(u){var i=list.indexOf(u);if(i>=0)go(i)}});
      var first=root.querySelector('.tlp-dd-b .tlp-grow');
      var start=0;
      if(first){var t=first.textContent.trim();p.variants.forEach(function(v){if(v.title===t&&v.featured_image){var i=list.indexOf(v.featured_image.src);if(i>=0)start=i}})}
      go(start);
    }).catch(function(){});
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})();
